/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantTotalNetWorthDto } from '../models/PagedResultDto_ParticipantTotalNetWorthDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_CreateUpdateParticipantTotalNetWorthDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_CreateUpdateParticipantTotalNetWorthDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantTotalNetWorthService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantTotalNetWorthParticipantTotalNetWorthsList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-total-net-worth/participant-total-net-worths-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantTotalNetWorth(
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_CreateUpdateParticipantTotalNetWorthDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-total-net-worth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantTotalNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantTotalNetWorth(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantTotalNetWorthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-total-net-worth',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantTotalNetWorth(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_CreateUpdateParticipantTotalNetWorthDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-total-net-worth/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantTotalNetWorth(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-total-net-worth/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantTotalNetWorth1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantTotalNetWorth_ParticipantTotalNetWorthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-total-net-worth/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
